<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentcolor">
    <path
      d="M18.75 22H5.25C3.46 22 2 20.54 2 18.75V5.25C2 3.46 3.46 2 5.25 2H18.75C20.54 2 22 3.46 22 5.25V18.75C22 20.54 20.54 22 18.75 22ZM5.25 4C4.56 4 4 4.56 4 5.25V18.75C4 19.44 4.56 20 5.25 20H18.75C19.44 20 20 19.44 20 18.75V5.25C20 4.56 19.44 4 18.75 4H5.25Z"
    />
    <path
      d="M7.16998 17L10.92 7H13.07L16.82 17H14.77L13.92 14.6H10.07L9.26998 17H7.16998ZM10.67 12.9H13.27L12.07 9.15H11.92L10.67 12.9Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
